import { connect } from 'react-redux'
import TireAvailability from './TireAvailability'
import { showContactStoreModal } from './actions'

const mapDispatchToProps = dispatch => ({
  showContactStoreModal: () => dispatch(showContactStoreModal())
})

export default connect(null, mapDispatchToProps)(TireAvailability)
